/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.333 7.333H2.275l4.196-4.196a.668.668 0 00-.943-.943L.195 7.528a.67.67 0 00.001.944l5.333 5.333a.663.663 0 00.942 0 .668.668 0 000-.943L2.275 8.667h13.058a.666.666 0 100-1.334z"/>'
  }
})
